import { Button, Space, Table, Tag } from 'antd';
import styles from './index.module.scss';

const { Column } = Table;

type Props = {
	data: any[];
	totalRecords: number;
	currentPage: number;
	pageSize: number;
	isLoading: boolean;
	tableChangeHandler: (pagination: any, filter: any, sorter: any) => void;
	onClearClick: (record: any) => void;
	onViewDetailsClick: (record: any) => void;
};

const formatDate = (value?: string | Date | null) => {
	if (!value) return '-';
	return new Date(value).toLocaleDateString('en-GB');
};

const FnfClearanceTable = ({
	data,
	totalRecords,
	currentPage,
	pageSize,
	isLoading,
	tableChangeHandler,
	onClearClick,
	onViewDetailsClick,
}: Props) => {
	return (
		<div className={styles['dynamic-table']}>
			<Table
				dataSource={data}
				scroll={{ y: 'calc(100vh - 360px)' }}
				pagination={{
					total: totalRecords,
					current: currentPage,
					pageSize,
					showSizeChanger: false,
					pageSizeOptions: [10, 20, 50, 100],
				}}
				onChange={tableChangeHandler}
				rowKey={(record) => record.contractId ?? record.employeeId}
				loading={isLoading}
			>
				<Column
					title="Employee"
					dataIndex="employeeName"
					key="employeeName"
					sorter
					render={(_: string, record: any) => (
						<span>
							{record.employeeName}
							<br />
							<small>{record.employeeCode}</small>
						</span>
					)}
				/>
				<Column
					title="Relieving Date"
					dataIndex="relievingDate"
					key="relievingDate"
					sorter
					render={(value: string) => formatDate(value)}
				/>
				<Column
					title="Last Pay Period"
					dataIndex="lastPayPeriod"
					key="lastPayPeriod"
				/>
				<Column
					title="FnF Status"
					dataIndex="isFNFClearedByUser"
					key="isFNFClearedByUser"
					sorter
					render={(cleared: boolean) =>
						cleared ? (
							<Tag color="success">Cleared</Tag>
						) : (
							<Tag color="warning">Pending</Tag>
						)
					}
				/>
				<Column
					title="Action"
					key="action"
					render={(_: unknown, record: any) => (
						<Space>
							{record.isFNFClearedByUser ? (
								<Button
									onClick={() => onViewDetailsClick(record)}
									style={{ "borderColor": "#584495", "color": "#584495" }}
								>
									View Details
								</Button>
							) : (
								<Button
									type="primary"
									onClick={() => onClearClick(record)}
								>
									Clear Leave & Gratuity
								</Button>
							)}
						</Space>
					)}
				/>
			</Table>
		</div>
	);
};

export default FnfClearanceTable;
